<template>
    <div>
        <div v-show="!mostrarRateios">
            <app-tabela
                v-if="contrato"
                :itens="contrato.comprometimentos"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="acoes" slot-scope="data">
                    <btn-mostrar-rateios
                        :comprometimento="data"
                        :dataServicos="dataServicos"
                        @atualizarComprometimento="comprometimento = $event"
                    ></btn-mostrar-rateios>
                </template>
                <template slot="nuValorComprometimento" slot-scope="data">
                    {{ data.nuValorComprometimento | currency }}
                </template>
            </app-tabela>
        </div>
        <div v-if="mostrarRateios">
            <rateios
                :contrato="contrato"
                :comprometimento="comprometimento"
                @atualizarComprometimento="comprometimento = $event"
            >
            </rateios>
        </div>
    </div>
</template>

<script>
import Rateios from './rateios/Rateios'
import BtnMostrarRateios from './BtnMostrarRateios'

export default {
    components: {
        Rateios,
        BtnMostrarRateios
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
            comprometimento: null,
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'chaveOrigem',
                    label: 'Id',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'vcHistorico',
                    label: 'Histórico',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtEmissao',
                    label: 'Data Emissão',
                    sortable: true,
                    tdClass: 'text-center',
                    type: 'date'
                },
                {
                    key: 'dtMovimento',
                    label: 'Data Movimento',
                    sortable: true,
                    tdClass: 'text-center',
                    type: 'date'
                },
                {
                    key: 'nuValorComprometimento',
                    label: 'Valor',
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    sortable: true,
                    tdClass: 'text-center',
                    type: 'status'
                }
            ],
            itensPorPagina: 0
        }
    },

    // created() {
    //     this.comprometimentos = this.contrato.comprometimentos
    // },

    computed: {
        mostrarRateios() {
            return this.comprometimento !== null
        }
    }
}
</script>
